import { render, staticRenderFns } from "./data22.vue?vue&type=template&id=d1ce056e&scoped=true"
import script from "./data22.vue?vue&type=script&lang=js"
export * from "./data22.vue?vue&type=script&lang=js"
import style1 from "./data22.vue?vue&type=style&index=1&id=d1ce056e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ce056e",
  null
  
)

export default component.exports